import { Link } from 'react-router-dom';
import { FOOTER_LINKS, SITE } from '../lib/config';
import { track } from '../lib/analytics';

export function Footer() {
  return (
    <footer className="border-t border-border-subtle bg-bg-elevated">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div>
            <Link to="/" className="flex items-center gap-2 text-lg font-bold text-text-primary">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-white">
                IE
              </span>
              {SITE.name}
            </Link>
            <p className="mt-2 max-w-xs text-sm text-text-secondary">
              Free AI image upscaler and enlarger online. No sign-up needed.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-6 gap-y-2">
            {FOOTER_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() =>
                  link.to === '/pricing'
                    ? track('pricing_click', { location: 'footer', plan: 'pro' })
                    : track('cta_click', { location: 'footer', target: link.to })
                }
                className="text-sm text-text-secondary hover:text-text-primary"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-8 border-t border-border-subtle pt-6 text-sm text-text-muted">
          © {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
